import { Injectable } from '@angular/core';
import { Fetcher } from '@shared/http/fetcher';
import type { Role } from './role';
import { map } from 'rxjs/operators';
import type { Observable } from 'rxjs';

export interface PatchRolePermissionsRequest {
    permissions: {
        id: string;
        enabled: boolean;
    }[]
}

@Injectable({
    providedIn: 'root',
})
export class RoleFetcher extends Fetcher<Role> {
    readonly modelName: string = 'Role';

    get resourceName(): string {
        return 'roles';
    }

    public patchRolePermissions(id: string, body: PatchRolePermissionsRequest): Observable<Role> {
        return this._patch(this._getUrl(id, 'permissions'), body).pipe(
            map(response => response.data),
        );
    }
}
